module.exports = __webpack_public_path__ + "static/media/icon-play.2868ec05.svg";